module.exports = __webpack_public_path__ + "media/images/products/retailers-customised-5-sample02-e2e81ba246d045d95aa72cc3ab8d9c47.jpg";